//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Lee_',
  data() {
    return {
      form: {
        risk_surgery: '0',
        ischemic_heart_disease: '0',
        congestive_heart_disease: '0',
        cerebrovascular_diseases: '0',
        diabetes: '0',
        serum:'0',
      },

      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = (form.risk_surgery ? 1:0) +
        (form.ischemic_heart_disease ? 1 :0) +
        (form.congestive_heart_disease ? 1 :0) +
        (form.cerebrovascular_diseases ? 1 :0) +
        (form.diabetes ? 1 :0) +
        (form.serum ? 1 :0) 
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Lee_.vue